import { ApiResponse } from "../types/api-response"
import { Cems } from "../types/cems"
import useAuth from "./useAuth"
import useSWR from "swr"

const useCems = (uuid?: string) => {
  const { fetcher } = useAuth()
  const url = "/cems/" + (uuid || "")

  const { data, mutate, error } = useSWR(url, (url) =>
    fetcher()
      .get<ApiResponse<Cems[]>>(url)
      .then(({ data }) => {
        return data.data
      })
  )

  return { data, mutate, error }
}
export default useCems
